// extracted by mini-css-extract-plugin
module.exports = {"button":"BcfWEy","container":"_3lAFKS","text":"z2N6W0","title":"_1dj8QD"};